import { Card } from "../../ui/card";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Textarea } from "../../ui/textarea";
import { Upload } from "lucide-react";
import { resolveMediaUrl } from "../../../lib/api";

export const HeroContentForm = ({ content, update, uploadingKey, onHeroUpload }) => (
  <Card className="p-6 space-y-4">
    <h3 className="font-semibold">Inicio</h3>
    <div>
      <Label>Título principal</Label>
      <Input data-testid="admin-content-hero-headline" value={content.hero_headline} onChange={(e) => update("hero_headline", e.target.value)} className="mt-1" />
    </div>
    <div>
      <Label>Frase principal</Label>
      <Textarea data-testid="admin-content-hero-tagline" value={content.hero_tagline} onChange={(e) => update("hero_tagline", e.target.value)} className="mt-1" />
    </div>
    <div>
      <Label>Foto principal — horizontal (escritorio)</Label>
      <p className="text-xs text-muted-foreground mb-1">Se muestra en computadoras. Recomendado: orientación horizontal, mínimo 1920×1080.</p>
      <div className="flex items-center gap-3 mt-1">
        {content.hero_image_desktop && (
          <img src={resolveMediaUrl(content.hero_image_desktop)} alt="Hero escritorio" className="h-14 w-20 object-cover rounded" />
        )}
        <Input data-testid="admin-content-hero-image-desktop" value={content.hero_image_desktop || ""} onChange={(e) => update("hero_image_desktop", e.target.value)} placeholder="URL de la imagen" />
        <label data-testid="admin-content-hero-upload-desktop-label" className="shrink-0 flex items-center gap-1 border rounded px-3 py-2 text-xs cursor-pointer hover:bg-secondary/50">
          <Upload size={14} /> {uploadingKey === "hero_image_desktop" ? "Subiendo..." : "Subir"}
          <input data-testid="admin-content-hero-upload-desktop-input" type="file" accept="image/*" className="hidden" onChange={(e) => onHeroUpload(e, "hero_image_desktop")} disabled={uploadingKey === "hero_image_desktop"} />
        </label>
      </div>
    </div>
    <div>
      <Label>Foto principal — vertical (móvil)</Label>
      <p className="text-xs text-muted-foreground mb-1">Se muestra en celulares y tablets. Recomendado: orientación vertical, mínimo 1080×1920. Si no subes una, se usará la horizontal.</p>
      <div className="flex items-center gap-3 mt-1">
        {content.hero_image_mobile && (
          <img src={resolveMediaUrl(content.hero_image_mobile)} alt="Hero móvil" className="h-20 w-14 object-cover rounded" />
        )}
        <Input data-testid="admin-content-hero-image-mobile" value={content.hero_image_mobile || ""} onChange={(e) => update("hero_image_mobile", e.target.value)} placeholder="URL de la imagen" />
        <label data-testid="admin-content-hero-upload-mobile-label" className="shrink-0 flex items-center gap-1 border rounded px-3 py-2 text-xs cursor-pointer hover:bg-secondary/50">
          <Upload size={14} /> {uploadingKey === "hero_image_mobile" ? "Subiendo..." : "Subir"}
          <input data-testid="admin-content-hero-upload-mobile-input" type="file" accept="image/*" className="hidden" onChange={(e) => onHeroUpload(e, "hero_image_mobile")} disabled={uploadingKey === "hero_image_mobile"} />
        </label>
      </div>
    </div>
  </Card>
);
